import { ENDPOINT } from 'api/endPoints/getLargestFloatChanges';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    ITableWidgetWrapperProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const largestFloatChanges: IHashmapItemWithCustomProps<ITableWidgetWrapperProps> = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
    ],
    elementId: 'largest-float-changes',
    componentKey: 'largestFloatChanges',
    title: 'Largest Float Changes',
    id: 'relationshipFloatChanges',
    reportStyle: {
        widgetSizesAvailable: { medium: MEDIUM, large: LARGE, extraLarge: EXTRA_LARGE },
        widgetInitialSize: LARGE,
    },
    endpoint: ENDPOINT,
};
